<template>
  <div
    class="message-audio"
    :class="[
      isMobile && 'message-audio-h5',
      message.flow === 'out' && 'reserve',
      message.hasRiskContent && 'disable',
    ]"
    @click.stop="play"
  >
    <div class="audio-icon-container">
      <Icon
        :class="{icon:true,play: isAudioPlaying}"
        width="16px"
        height="16px"
        :file="currentAudioIcon"
      />
    </div>
    <span
      class="time"
      :style="{ width: `${data.second * 2 + 20}px` }"
    >
      {{ data.second || 1 }}"
    </span>
    <audio
      ref="audioRef"
      :src="audioUrl"
    />
  </div>
</template>

<script lang="ts" setup>
import vue from '../../../../adapter-vue';
import Icon from '../../../common/Icon.vue';
import audioIcon1 from '../../../../assets/audio_icon_1.svg';
import audioIcon2 from '../../../../assets/audio_icon_2.svg';
import audioIcon3 from '../../../../assets/audio_icon_3.svg';
import { isMobile } from '../../../../utils/env';
import {
  Toast,
  TOAST_TYPE,
} from '../../../common/Toast/index-web';
import { TUITranslateService } from '../../../../@aidesk/uikit-engine';
const { watchEffect, ref, onMounted, onUnmounted, computed } = vue;

interface IEmits {
  (e: 'setAudioPlayed', messageID: string): void;
}

const emits = defineEmits<IEmits>();
const props = defineProps({
  content: {
    type: Object,
    default: () => ({}),
  },
  messageItem: {
    type: Object,
    default: () => ({}),
  },
});

const data = ref();
const message = ref();
const isAudioPlaying = ref();
const audioRef = ref<HTMLAudioElement>();
const audioIcons = [audioIcon1, audioIcon2, audioIcon3];
const currentAudioIconIndex = ref(2);
const audioUrl = ref('');
const currentAudioIcon = computed(() => audioIcons[currentAudioIconIndex.value]);
let audioIconTimer: any = null;

onMounted(() => {
  if (audioRef.value) {
    audioRef.value.addEventListener('ended', onAudioEnded);
    audioRef.value.addEventListener('pause', onAudioPaused);
  }
});

onUnmounted(() => {
  if (audioRef.value) {
    audioRef.value.removeEventListener('ended', onAudioEnded);
    audioRef.value.removeEventListener('pause', onAudioPaused);
  }
});

watchEffect(() => {
  message.value = props.messageItem;
  data.value = props.content;
  audioUrl.value = data.value.url || message.value.payload.remoteAudioUrl;
});

function play() {
  if (message.value.hasRiskContent || !audioRef.value) {
    return;
  }
  if (!audioRef.value.paused) {
    audioRef.value.pause();
    audioRef.value.currentTime = 0;
    isAudioPlaying.value = false;
    return;
  }
  const audios = document.getElementsByTagName('audio');
  Array.from(audios).forEach((audio) => {
    if (!audio.paused) {
      audio.pause();
      audio.currentTime = 0;
    }
  });
  try {
    if (!audioUrl.value) {
      const message = `${TUITranslateService.t("TUIChat.语音播放失败")}`;
      Toast({
        message,
        type: TOAST_TYPE.ERROR,
        duration: 2000,
      });
      return;
    }
    audioRef.value.play();
    if (!audioIconTimer) {
      audioIconTimer = setInterval(() => {
        currentAudioIconIndex.value = (currentAudioIconIndex.value + 1) % audioIcons.length;
      }, 500);
    }
    
  } catch (e) {
    console.warn(e);
  }
  isAudioPlaying.value = true;
  if (message.value.flow === 'in') {
    emits('setAudioPlayed', message.value.ID);
  }
}

function initAudioIcon() {
  clearInterval(audioIconTimer);
  audioIconTimer = null;
  currentAudioIconIndex.value = 2;
}

function onAudioEnded() {
  isAudioPlaying.value = false;
  initAudioIcon();
}

function onAudioPaused() {
  isAudioPlaying.value = false;
  initAudioIcon();
}
</script>
<style lang="scss" scoped>
@import "../../style/common";
.message-audio {
  flex-direction: row;
  display: flex;
  flex: 0 0 auto;
  cursor: pointer;
  overflow: hidden;
  align-items: center;

  .time {
    flex: 1 1 auto;
    max-width: 300px;
    text-align: start;
  }

  audio {
    width: 0;
    height: 0;
  }
}

.disable {
  cursor: not-allowed;
}

.audio-icon-container {
  flex: 0 0 auto;
  position: relative;
  margin: 0 7px 0 0;
  overflow: hidden;
}

.message-audio.reserve {
  flex-direction: row-reverse;

  .time {
    text-align: end;
  }

  .audio-icon-container {
    margin: 0 0 0 4px;
  }
}
</style>
